import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/layer/index';
import Utils from '../../../utils/util';
import { layerLink } from '../../layerGroup/link';

function findNextLayerCube(target: CubeId, dragCubes: CubeId[]): CubeId|null {
    let nextCube: CubeId|null = CubeTree.findNextCube(target, dragCubes);

    if (CubeTree.isInStage(target)) {
        return nextCube;
    }

    let itsLayer: CubeId = CubeTree.findCubeLayer(target);
    let grouped: boolean = UIToolkit.layerIsGrouped(itsLayer);

    if (UIToolkit.layoutType(itsLayer) === '|-|--|---') {
        return nextCube;
    }

    if (!grouped) {
        return nextCube;
    }

    if (nextCube) {
        return nextCube;
    }

    let link: LinkedListInstance|null = layerLink(itsLayer);
    let behindLinkLayers: CubeId[] = link.behindOf(itsLayer);
    let behindCubes: CubeId[] = CubeTree.findParentsChild(behindLinkLayers);

    return Utils.findListFirstItem(behindCubes, dragCubes);
}

export {
    findNextLayerCube
};
